<template>
  <div class="contain contractor">
    <div class="landing_bg"></div>
    <div class="contractor_icon">
        <img class="bg1" src="../assets/images/bg1.png" />
        <img class="bg2" src="../assets/images/bg2.png" />
        <img class="logo" src="../assets/images/logo.png" />
        <div class="contractor_icon_inside">
          <div class="circle"></div>
          <div class="triangle"></div>
          <div class="rect"></div>
        </div>
    </div>
    <div class="landing_contain flex">
      <div>
        <div class="logo">
          <img src="../assets/images/white_logo.png" />
        </div>
        <Registered></Registered>
      </div>
    </div>
  </div>
</template>
 
<style lang="scss">
.contractor {
  .landing_contain{
    justify-content: flex-end;
  }
  .contractor_icon{
    width: 100%;
    position: fixed;
    height: calc(100vh - 100px);
    top:50px;
    left: 0;
    img {
      position: absolute;
      &.bg1 {
        top: 0px;
        left: -10px;
      }
      &.bg2 {
        left: 200px;
        top: 350px;
      }
      &.logo {
        top: 100px;
        left: 10%;
      }
    }
    .contractor_icon_inside {
      position: absolute;
      top: 25%;
      left: 27%;
      width: 280px;
      div {
        position: absolute;
      }
      .circle {
        background: var(--subColor);
        width: 110px;
        height: 110px;
        border-radius: 50%;
        top: 250px;
        z-index: 2;
        // animation: circle 1s 0.5s backwards;
      }
      // @keyframes circle {
      //   0% {
      //     opacity: 0;
      //     top: 300px;
      //   }
      //   100% {
      //     opacity: 1;
      //     top: 250px;
      //   }
      // }
      .triangle {
        z-index: 1;
        top: 100px;
        left: -120px;
        width: 245px;
        height: 213px;
        background: #fff21f;
        opacity: 0.9;
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        // animation: triangle 1.5s 0.1s backwards;
      }
      // @keyframes triangle {
      //   0% {
      //     left: -300px;
      //     opacity: 0;
      //     transform: rotate(250deg);
      //   }
      //   100% {
      //     opacity: 0.9;
      //     top: 100px;
      //     left: -120px;
      //     transform: rotate(0deg);
      //   }
      // }
      .rect {
        top: 180px;
        left: 50px;
        z-index: 3;
        width: 140px;
        height: 140px;
        background: #2ed0ff;
        opacity: 0.8;
        // animation: rect 1s 0.7s backwards;
      }
      // @keyframes rect {
      //   0% {
      //     opacity: 0;
      //     left: 100px;
      //   }
      //   100% {
      //     opacity: 0.8;
      //     top: 180px;
      //     left: 50px;
      //   }
      // }
    }
  }
}
</style>

<script>
import Registered from "./Contractor/Registered.vue";
export default {
  name: "home",
  data() {
    return {};
  },
  components: {
    Registered
  },
  methods: {}
};
</script>
